/**
 * Textos del Catàleg (`ca`): ajunta els fitxers de cada tall. Cablejat a `ca.ts` amb un sol
 * `...catalegCa`; així cada tall edita només el seu fitxer.
 */

import { supplierArticlesCa } from './supplierArticles.ca.js';
import { ftRequestCa } from './ftRequest.ca.js';
import { articleRestrictionsCa } from './articleRestrictions.ca.js';

export const catalegCa = {
  ...supplierArticlesCa,
  ...ftRequestCa,
  ...articleRestrictionsCa,
} as const;
